//import "./iot2.css";

import React from "react";
import ScrollHooks from "../ScrollHooks.js";
import AjaxHooks from "../AjaxHooks";
//import AjaxHooks from "../AjaxHooks";

const Iot2 = () => {
  return (
    <div>
      "texto de prueba"
      <ScrollHooks />
      {/* <AjaxHooks /> */}
      <ul className="iotGrid-container">
        <AjaxHooks />
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">
          <ScrollHooks />
          item 5
        </li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
      </ul>
    </div>
  );
};

export default Iot2;
